import { ConceptType } from "@/utils/analysis";
import { Document, Token } from "@/tools/msa/models";

const emptyArray: unknown[] = [];

export const mapItemsByTokens = (document: Document, types: ConceptType[]) => {
  return document.items
    .filter(
      item =>
        (item.type === "concept_match" &&
          types.includes(item.match.concept.type)) ||
        item.type === "code_match" ||
        item.type === "custom_match"
    )
    .flatMap(item =>
      (item as any).match.locations.flat(1).map((token: Token) => [item, token])
    )
    .reduce(
      (map, [item, token]) =>
        map.set(token, [...(map.get(token) || emptyArray), item]),
      new Map(document.tokens.map(token => [token, emptyArray]))
    );
};
